import { Link } from "react-router-dom";
import { allArticles, categories } from "@/mocks/articles";

interface ArticleCard {
  article: (typeof allArticles)[0];
  imageUrl: string;
  catName: string;
}

const featuredCards: ArticleCard[] = [
  {
    article: allArticles.find((a) => a.id === 1)!,
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20writing%20desk%20with%20soft%20natural%20light%20from%20window%2C%20open%20notebook%20with%20handwritten%20Chinese%20characters%2C%20wooden%20ruler%20nearby%2C%20gentle%20shadows%2C%20nostalgic%20academic%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20editorial%20style%20photography&width=800&height=500&seq=article-1&orientation=landscape",
    catName: "校园惩罚场景",
  },
  {
    article: allArticles.find((a) => a.id === 9)!,
    imageUrl: "https://readdy.ai/api/search-image?query=An%20elderly%20hand%20holding%20a%20thin%20bamboo%20whip%20in%20a%20traditional%20Chinese%20courtyard%20house%2C%20winter%20snow%20outside%20the%20window%2C%20warm%20interior%20light%2C%20nostalgic%20atmosphere%2C%20emotional%20and%20sentimental%2C%20cream%20and%20wood%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-9&orientation=landscape",
    catName: "成长记叙文",
  },
  {
    article: allArticles.find((a) => a.id === 3)!,
    imageUrl: "https://readdy.ai/api/search-image?query=A%20traditional%20wooden%20ruler%20hanging%20on%20a%20study%20room%20wall%2C%20aged%20bamboo%20texture%2C%20calligraphy%20brushes%20nearby%2C%20warm%20natural%20sunlight%2C%20heritage%20and%20discipline%20theme%2C%20cream%20and%20brown%20tones%2C%20editorial%20style&width=800&height=500&seq=article-3&orientation=landscape",
    catName: "成长记叙文",
  },
  {
    article: allArticles.find((a) => a.id === 12)!,
    imageUrl: "https://readdy.ai/api/search-image?query=A%20feather%20duster%20lying%20on%20a%20wooden%20bedside%20table%20in%20a%20cozy%20Chinese%20bedroom%2C%20soft%20evening%20light%2C%20gentle%20shadows%2C%20warm%20and%20intimate%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-12&orientation=landscape",
    catName: "家庭惩罚场景",
  },
  {
    article: allArticles.find((a) => a.id === 5)!,
    imageUrl: "https://readdy.ai/api/search-image?query=A%20wooden%20pointer%20stick%20on%20a%20classroom%20teacher%20desk%2C%20chalkboard%20in%20background%2C%20morning%20sunlight%20streaming%20through%20window%2C%20nostalgic%20school%20atmosphere%2C%20warm%20cream%20and%20green%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-5&orientation=landscape",
    catName: "校园惩罚场景",
  },
  {
    article: allArticles.find((a) => a.id === 2)!,
    imageUrl: "https://readdy.ai/api/search-image?query=An%20old%20worn%20broom%20made%20of%20sorghum%20straw%20leaning%20against%20a%20traditional%20Chinese%20courtyard%20wall%2C%20afternoon%20sunlight%2C%20rustic%20and%20nostalgic%2C%20warm%20earthy%20tones%2C%20textured%20and%20sentimental%2C%20editorial%20photography&width=800&height=500&seq=article-2&orientation=landscape",
    catName: "家庭惩罚场景",
  },
];

export default function FeaturedArticles() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">精选范文推荐</h2>
            <p className="text-sm text-foreground-600">精选优秀惩罚场景作文，感受文字的力量</p>
          </div>
          <Link
            to="/category/fanwen-shangxi"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredCards.map((item) => (
            <Link
              key={item.article.id}
              to={`/article/${item.article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={item.imageUrl}
                  alt={item.article.title}
                  title={`${item.article.title} - 打屁股作文范文`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 rounded-full text-xs font-medium">
                  {item.catName}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {item.article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.article.author}</span>
                  <span>{item.article.date} · {item.article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/fanwen-shangxi"
            className="inline-flex items-center gap-1 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看全部范文 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}